export default {
  alaska: {
    name: 'Alaska Airlines Mileage Plan™',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Alaska-Airlines.zip',
  },
  alliant: {
    name: 'Alliant Credit Union',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Alliant-Credit-Union.zip',
  },
  ally: {
    name: 'Ally Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Ally-Bank.zip',
  },
  amex: {
    name: 'American Express',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/American-Express-v2.zip',
  },
  ascent: {
    name: 'Ascent',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Ascent.zip',
  },
  capitalone: {
    name: 'Capital One',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Capital-One.zip',
  },
  chase: {
    name: 'Chase',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Chase-v2.zip',
  },
  collegeave: {
    name: 'College Ave',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/College-Ave.zip',
  },
  commonbond: {
    name: 'CommonBond',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/CommonBond.zip',
  },
  delta: {
    name: 'Delta SkyMiles',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Delta.zip',
  },
  discover: {
    name: 'Discover',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Discover.zip',
  },
  earnest: {
    name: 'Earnest',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Earnest.zip',
  },
  fidelity: {
    name: 'Fidelity Investments',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Fidelity-Investments_v2.zip',
  },
  flagstar: {
    name: 'Flagstar Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Flagstar-Bank.zip',
  },
  geico: {
    name: 'GEICO',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Geico.zip',
  },
  gemini: {
    name: 'Gemini',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Gemini.zip',
  },
  havenlife: {
    name: 'Haven Life',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Haven-Life.zip',
  },
  isl: {
    name: 'ISL',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/ISL.zip',
  },
  lakemichigan: {
    name: 'Lake Michigan Credit Union',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Lake-Michigan-Credit-Union.zip',
  },
  lenderfi: {
    name: 'LenderFi',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/LenderFi.zip',
  },
  lightstream: {
    name: 'LightStream',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/LightStream.zip',
  },
  marcus: {
    name: 'Marcus by Goldman Sachs',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Marcus-by-Goldman-Sachs.zip',
  },
  nasb: {
    name: 'North American Savings Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/North-American-Savings-Bank-v2.zip',
  },
  pennymac: {
    name: 'PennyMac',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/PennyMac.zip',
  },
  radisson: {
    name: 'Radisson',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Radisson.zip',
  },
  schwab: {
    name: 'Schwab Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Schwab-Bank.zip',
  },
  sofi: {
    name: 'SoFi',
    badgeLink: 'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/SoFi.zip',
  },
  tdameritrade: {
    name: 'TD Ameritrade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/TD-Ameritrade.zip',
  },
  tradestation: {
    name: 'TradeStation',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/TradeStation.zip',
  },
  upgrade: {
    name: 'Upgrade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Upgrade.zip',
  },
  upstart: {
    name: 'Upstart',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Upstart.zip',
  },
  usbank: {
    name: 'U.S. Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/US-Bank.zip',
  },
  vanguarddigital: {
    name: 'Vanguard Digital Advisor',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Vanguard.zip',
  },
  wealthfront: {
    name: 'Wealthfront',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Wealthfront.zip',
  },
  wellsfargo: {
    name: 'Wells Fargo',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Wells-Fargo.zip',
  },
  worldofhyatt: {
    name: 'World of Hyatt',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/World-of-Hyatt.zip',
  },
  zoefinancial: {
    name: 'Zoe Financial',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Zoe-Financial.zip',
  },
  zynlobank: {
    name: 'Zynlo Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/NW-awards/2022/badges/Zynlo-Bank.zip',
  },
};
